import React, { useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Dog from './Dog';
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";

function DogsM() {

    const [dogs, setDogs] = useState([]);
    
        useEffect(() => {
            fetch('dogs.json')
            .then(response => response.json())
            .then(data => setDogs(data.dogsM))
            .catch(error => console.log(error))
        }, []);
    
    const location = useLocation()

    const [key, setKey] = location.state ? useState(location.state.name) : useState('Tommy');

    return (
        <div className='container'>
            <Helmet>
                <title>Nos Mâles golden retriever</title>
                <meta
                    name="description"
                    content="Retrouvez les chiens de travail de l'élevage des Bruyères de Servière dans le Puy-de-dôme avec notamment leur pedigree et leur confirmation LOF"
                />
            </Helmet>
            <Tabs
                id="dogs-presentation"
                activeKey={key}
                onSelect={(d) => setKey(d)}
                className='mb-3'
                >
                    {dogs.map((dog) => (
                        <Tab eventKey={dog.name} title={dog.name}>
                            <Dog dog={dog}/>
                        </Tab>
                    ))}
            </Tabs>
        </div>
    );
}

export default DogsM;